import React from "react";
import { useEffect } from "react";
import { useState } from "react";

import UserLayout from "../../components/user-layout/UserLayout";
import styles from "./jobPost.module.scss";
import jobService from "../../utils/services/jobService";
import { useParams } from "react-router-dom";
import authService, { user$ } from "../../utils/services/authService";

const JobPost = () => {
  const [jobPost, setJobPost] = useState();
  const [user, setUser] = useState();
  const [applied, setApplied] = useState(false);

  const userData = authService.getUserData();
  const { id } = useParams();

  useEffect(() => {
    jobService.getJobById(id, userData).then((res) => {
      if (res.data.success) {
        setJobPost(res.data.data);
      }

      authService.getUserById(userData);

      user$.subscribe((data) => {
        if (user !== data) {
          setUser(data.data.data[0]);
        }
      });
    });
  }, []);

  useEffect(() => {
    if (user?.role === "developer") {
      user.appliedJobs?.map((job) => {
        if (job._id === id) {
          console.log("ids equal");
          return setApplied(true);
        }
        /* else {
          console.log("ids not equal");
          return setApplied(false);
        } */
      });
    }
  }, [user]);
  console.log(applied);
  console.log(user);
  console.log(jobPost);
  const applyHandle = async () => {
    const data = {
      jobId: id,
    };
    try {
      const result = await authService.applyJob(data, userData);
      if (result) {
        authService.getUserById(userData);

        user$.subscribe((data) => {
          if (user !== data) {
            setUser(data.data.data[0]);
          }
        });
      }
    } catch (error) {
      console.log(error.message);
    }
  };
  return (
    <UserLayout>
      <header className={styles.jobHeader}>
        <h2>Are you our new colleague? {jobPost?.requirements.jobCategory}?</h2>
      </header>
      <section className={styles.jobPageWrapper}>
        <section className={styles.jobDescriptionWrapper}>
          <p className={styles.jobDescriptionWrapper_title}>Job description</p>
          <p className={styles.jobDescriptionWrapper_body}>
            {jobPost?.description}
          </p>
        </section>
        <section className={styles.jobTechWrapper}>
          {jobPost &&
            jobPost?.tech.map((tech, index) => (
              <span key={index} className={styles.jobTechWrapper_item}>
                {tech}
              </span>
            ))}
        </section>
        <section className={styles.requirementsWrapper}>
          <div className={styles.requirementsWrapper_item}>
            <img className={styles.reqImg} src="" alt="" />
            <p className={styles.reqTitle}>Salary</p>
            <p className={styles.reqValue}>
              {jobPost?.requirements.salary} SEK/Month
            </p>
          </div>
          <div className={styles.requirementsWrapper_item}>
            <img className={styles.reqImg} src="" alt="" />
            <p className={styles.reqTitle}>Job type</p>
            <p className={styles.reqValue}>{jobPost?.requirements.jobType}</p>
          </div>
          <div className={styles.requirementsWrapper_item}>
            <img className={styles.reqImg} src="" alt="" />
            <p className={styles.reqSalary}>Job category</p>
            <p className={styles.reqValue}>
              {jobPost?.requirements.jobCategory}
            </p>
          </div>
          <div className={styles.requirementsWrapper_item}>
            <img className={styles.reqImg} src="" alt="" />
            <p className={styles.reqSalary}>Experience</p>
            <p className={styles.reqValue}>
              {jobPost?.requirements.experience} years
            </p>
          </div>
          <div className={styles.requirementsWrapper_item}>
            <img className={styles.reqImg} src="" alt="" />
            <p className={styles.reqSalary}>Location</p>
            <p className={styles.reqValue}>{jobPost?.requirements.location}</p>
          </div>
          <div className={styles.requirementsWrapper_item}>
            <img className={styles.reqImg} src="" alt="" />
            <p className={styles.reqSalary}>Remote</p>
            <p className={styles.reqValue}>{jobPost?.requirements.remote}</p>
          </div>
        </section>
        <section className={styles.companyInfo}>
          <h3 className={styles.companyInfo_name}>
            {jobPost?.companyInfo.companyName}
          </h3>
          <p className={styles.companyInfo_size}>
            Size:{" "}
            <span className={styles.companyValue}>
              {jobPost?.companyInfo.companySize}
            </span>
          </p>
          <p className={styles.companyInfo_type}>
            Type:{" "}
            <span className={styles.companyValue}>
              {jobPost?.companyInfo.companyType}
            </span>
          </p>
          <p className={styles.companyInfo_descTitle}>Company description</p>
          <p className={styles.companyInfo_desc}>
            {jobPost?.companyInfo.companyDescription}
          </p>
        </section>
        {user?.role === "developer" ? (
          <>
            {!applied ? (
              <section className={styles.applyBar}>
                <button
                  className={styles.applyBar_btn}
                  onClick={(e) => {
                    applyHandle();
                  }}
                >
                  Apply Now!
                </button>
              </section>
            ) : (
              ""
            )}
          </>
        ) : (
          ""
        )}
      </section>
    </UserLayout>
  );
};

export default JobPost;
